<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

  .div-map {
    background: white;
    width: 15%;
    z-index: 1000;
    position: absolute;
    bottom: 10px;
    left: 0;
    margin-left: 10px;
    padding: 10px;
    border-radius: 5px;
  }
  .leaflet-topcenter {
    padding-top: 5px;
    position: absolute;
    top: 0px;
    text-align: center;
    left: 0px;
    width: calc(100% - 10px)
  }
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4">
        <div class="vx-col w-full">
            <vx-card class="grid-view-item overflow-hidden">
                <div id="container-map" v-if="status_mapa">
                    <l-map :interactive="false" :center="center" :zoom="10" ref="mymap" style="height: 100%; overflow: hidden;" :options="{attributionControl: false}">
                      <l-control-attribution position="bottomright" prefix="Spore Cloud"></l-control-attribution>
                      <l-control-layers :collapsed="true" :position="layersPosition" :sort-layers="true"></l-control-layers>
                      <l-control :position="layersPosition">
                        <vs-button v-if="!banderaHeatMap" @click="showFiltrar = !showFiltrar" class="float-right text-grey-dark border-2 border-solid border-grey py-2 px-3" color="white" type="filled"><iconBase iconName="filter_list" :width="24" :height="24" iconColor="#b8c2cc"><iconFilter/></iconBase></vs-button>
                        <div v-if="showFiltrar" class="bg-white border-2 border-solid border-grey p-4 rounded-lg float-right mr-2">
                          <div class="font-bold mb-2 text-center">{{$t('Labels.Filter') + ' ' +$t('Labels.By')}}:</div>
                          <div class="vx-row mb-6">
                            <div class="vx-col w-1/2">
                              <label class="font-bold">{{$t('Labels.AccountNumber')}}</label>
                              <vs-input v-model="filters.numCta"/>
                            </div>
                            <div class="vx-col w-1/2">
                              <label class="font-bold">{{$t('Labels.NumberOfMeter')}}</label>
                              <vs-input v-model="filters.numMedidor"/>
                            </div>
                          </div>
                          <div class="vx-row mb-6" v-if="maxFlow > 0">
                            <div class="vx-col w-1/2">
                              <label class="font-bold">{{$t('Labels.TotalCubicMeters')}}</label>
                              <br>
                              <vs-input onkeypress="return event.charCode>=48 && event.charCode<=57 || event.charCode==46" class="align-middle inline-block p-1" :placeholder="$t('Labels.From')" v-model="filters.minMts3" maxlength="6"/>
                            </div>
                            <div class="vx-col w-1/2">
                              <label class="font-bold"></label>
                              <br>
                              <vs-input onkeypress="return event.charCode>=48 && event.charCode<=57 || event.charCode==46" class="align-middle inline-block p-1" :placeholder="$t('Labels.To')" v-model="filters.maxMts3" maxlength="6"/>
                            </div>
                          </div>
                          <div class="vx-row mb-6" v-if="maxFlow > 0">
                            <div class="vx-col w-1/2">
                              <label  class="font-bold">{{$t('Labels.CubicMetersPerHour')}}</label>
                              <br>
                              <vs-input onkeypress="return event.charCode>=48 && event.charCode<=57 || event.charCode==46" class="align-middle inline-block p-1" :placeholder="$t('Labels.From')" v-model="filters.minFlow" maxlength="6"/>
                            </div>
                            <div class="vx-col w-1/2">
                              <label class="font-bold"></label>
                              <br>
                              <vs-input onkeypress="return event.charCode>=48 && event.charCode<=57 || event.charCode==46" class="align-middle inline-block p-1" :placeholder="$t('Labels.To')" v-model="filters.maxFlow" maxlength="6"/>
                            </div>
                          </div>
                          <div class="vx-row mb-6">
                            <div class="vx-col w-1/1">
                              <label class="font-bold">{{$t('Labels.Type')}}</label>
                              <v-select class="w-full" :options="types" v-model="filters.type" :reduce="v => v.value" :clearable="false"/>
                            </div>
                          </div>
                          <div class="vx-row">
                            <div class="vx-col w-1/2 p-2">
                              <vs-button @click="getMapa()" color="primary" class="w-full">{{$t('Labels.Filter')}}</vs-button>
                            </div>
                          </div>
                        </div>
                      </l-control>
                      <l-control :position="layersPosition">
                        <vs-button size="large" v-if="banderaFilter" color="#b70000" title="Limpiar Filtros" @click="filterAdd()" icon-pack="feather" icon="icon-filter"></vs-button>
                      </l-control>
                      <l-control :position="layersPosition">
                        <vs-button v-if="!banderaHeatMap" size="large" :color="banderaArea ? '#7577C8' : '#c1c1c1'" title="Selección de área" @click="seleccionArea()" class="p-3">
                          <img :src="require('@/assets/images/icons/polygon.svg')" alt="">
                        </vs-button>
                      </l-control>
                      <l-control :position="layersPosition">
                        <vs-button size="large" v-if="!banderaHeatMap" :color="banderaCluster ? '#7577C8' : '#c1c1c1'" title="Agrupamiento" @click="filterCluster()" icon-pack="feather" icon="icon-map-pin"></vs-button>
                      </l-control>
                      <l-control :position="layersPosition">
                        <vs-button size="large" :color="banderaHeatMap ? '#7577C8' : '#c1c1c1'" title="mapa de calor" @click="filterHeatMap()" icon-pack="feather" icon="icon-thermometer"></vs-button>
                      </l-control>
                      <l-control position="verticalcenterright" class="leaflet-topcenter">
                        <vs-button color="#7577C8" class="m-1" style="width: 10%;" @click="filterAdd(false)">
                          <label for="" style="font-size: 18px;"><b>{{ $t(`Labels.Ready`) }}</b></label><br>
                          <label for="" style="font-size: 18px;"><b>{{dashboard.noAlert}}</b></label><br>
                        </vs-button>
                        <vs-button color="#b70000" class="m-1" style="width: 10%;" @click="filterAdd(true)">
                          <label for="" style="font-size: 18px;"><b>{{ $t(`Labels.Alerts`) }}</b></label><br>
                          <label for="" style="font-size: 18px;"><b>{{dashboard.alert}}</b></label><br>
                        </vs-button>
                      </l-control>
                        <l-tile-layer :key="tileProvider.name" :name="tileProvider.name" :url="tileProvider.url" :visible="tileProvider.visible" layer-type="base" v-for="tileProvider in tileProviders">
                        </l-tile-layer>
                        <l-heatmap v-if="banderaHeatMap" :lat-lng="latlngs" :radius="30"/>
                        <l-rectangle :bounds="rectangle.latlngs" :l-style="rectangle.style" v-if="rectangle.visible"></l-rectangle>
                        <div class="mt-4 div-map">
                          <div class="vx-row">
                            <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1 m-2" style="font-size: 18px;">
                              <label class="mr-2" style="color: #7577C8;"><b>{{dashboard.gaugesCount}}</b></label><br>
                              <label class="mr-2">{{ $t(`Labels.MetersCount`) }}</label>
                            </div>
                            <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1 m-2" style="font-size: 18px;">
                              <label class="mr-2" style="color: #7577C8;"><b>{{dashboard.totalMeters}} <span class="unit">m³</span></b></label><br>
                              <label class="mr-2">{{ $t(`Labels.TotalCubicMeters`) }}</label>
                            </div>
                            <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1 m-2" style="font-size: 18px;">
                              <label class="mr-2" style="color: #7577C8;"><b>{{dashboard.totalPerHour}} <span class="unit">m³/h</span></b></label><br>
                              <label class="mr-2">{{ $t(`Labels.CubicMetersPerHour`) }}</label>
                            </div>
                          </div> 
                        </div>
                        <v-marker-cluster ref="clusterRef" v-if="(banderaCluster && !banderaHeatMap)">
                          <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                              <l-icon :icon-anchor="staticAnchor">
                                  <img :src="require(`@/assets/images/markers/${item.status}.svg`)" style="width: 30px !important" alt="icono marcador"/>
                              </l-icon>
                              <l-popup v-if="item.deviceType === 'water'">
                                <div class="popup">
                                  <gridPrincipalItem
                                    :img="(item.meter_type != '0' ? 'medidor' : 'medidores')"
                                    :name="item.num_cta"
                                    :description="$t('Labels.AccountNumber')"
                                  ></gridPrincipalItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="parseFloat(item.mts3).toFixed(3)"
                                    :description="$t('Labels.TotalCubicMeters')"
                                    img="metros_totales"
                                    unit="m³"
                                  ></valueItem>
                                  <valueItem
                                    :value="parseFloat(item.flow).toFixed(3)"
                                    :description="$t('Labels.CubicMetersPerHour')"
                                    img="metros_totales"
                                    unit="m³/h"
                                  ></valueItem>
                                  <valueItem
                                    :value="item.num_medidor"
                                    :description="$t('Labels.NumberOfMeter')"
                                    img="medidor"
                                  ></valueItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="item.ultima_lectura"
                                    img="lectura"
                                    :relativeTime="true"
                                  ></valueItem>
                                  <div class="ml-3 mt-2" @click="getDetailLog(item)" >
                                    <statusItem
                                      :status="parseInt(item.num_alert) === 0 ?'success-spore':'danger-spore'"
                                      :description="parseInt(item.num_alert) === 0 ? $t('Labels.Ready') : parseInt(item.num_alert) >= 2 ? $t(`Labels.${nameAlert(item).name}`) + ' +' : $t(`Labels.${nameAlert(item).name}`)"
                                    />
                                  </div>
                                  <div class="text-center"><vs-button color="primary" @click="deviceInformation(item.id)">Ver Más</vs-button></div>
                                </div>
                              </l-popup>
                              <l-popup v-if="item.deviceType === 'valve'">
                                <div class="popup">
                                  <gridPrincipalItem
                                    img="electrovalve"
                                    :name="item.num_valve"
                                    :description="$t('Labels.ClientNumber')"
                                  ></gridPrincipalItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="item.valve_opening"
                                    :description="$t('Labels.Opening')"
                                    img="opening"
                                    unit="%"
                                  ></valueItem>
                                  <valueItem
                                    :value="item.tipo_abastecimiento == 'R'? $t('Labels.Residential'):$t('Labels.Commercial')"
                                    :description="$t('Labels.Type')"
                                    :img="item.tipo_abastecimiento == 'R'? 'residencial': 'comercial'"
                                  ></valueItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="formDate(item.updated_at, 'dayJs')"
                                    :description="$t('Labels.LastUpdated')"
                                    img="fecha"
                                  ></valueItem>
                                  <div class="text-center"><vs-button color="primary"  size="regular" @click="deviceInformation(item.id)">Ver Más</vs-button></div>
                                </div>
                              </l-popup>
                          </l-marker>
                        </v-marker-cluster>
                        <div v-if="(!banderaCluster && !banderaHeatMap)">
                          <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                            <l-icon :icon-anchor="staticAnchor">
                                <img :src="require(`@/assets/images/markers/${item.status}.svg`)" style="width: 30px !important" alt="icono marcador"/>
                            </l-icon>
                            <l-popup v-if="item.deviceType === 'water'">
                                <div class="popup">
                                  <gridPrincipalItem
                                    :img="(item.meter_type != '0' ? 'medidor' : 'medidores')"
                                    :name="item.num_cta"
                                    :description="$t('Labels.AccountNumber')"
                                  ></gridPrincipalItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="parseFloat(item.mts3).toFixed(3)"
                                    :description="$t('Labels.TotalCubicMeters')"
                                    img="metros_totales"
                                    unit="m³"
                                  ></valueItem>
                                  <valueItem
                                    :value="parseFloat(item.flow).toFixed(3)"
                                    :description="$t('Labels.CubicMetersPerHour')"
                                    img="metros_totales"
                                    unit="m³/h"
                                  ></valueItem>
                                  <valueItem
                                    :value="item.num_medidor"
                                    :description="$t('Labels.NumberOfMeter')"
                                    img="medidor"
                                  ></valueItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="item.ultima_lectura"
                                    img="lectura"
                                    :relativeTime="true"
                                  ></valueItem>
                                  <div class="ml-3 mt-2" @click="getDetailLog(item)" >
                                    <statusItem
                                      :status="parseInt(item.num_alert) === 0 ?'success-spore':'danger-spore'"
                                      :description="parseInt(item.num_alert) === 0 ? $t('Labels.Ready') : parseInt(item.num_alert) >= 2 ? $t(`Labels.${nameAlert(item).name}`) + ' +' : $t(`Labels.${nameAlert(item).name}`)"
                                    />
                                  </div>
                                <div class="text-center"><vs-button color="primary" @click="deviceInformation(item.id)">Ver Más</vs-button></div>
                            </div>
                            </l-popup>
                            <l-popup v-if="item.deviceType === 'valve'">
                                <div class="popup">
                                  <gridPrincipalItem
                                    img="electrovalve"
                                    :name="item.num_valve"
                                    :description="$t('Labels.ClientNumber')"
                                  ></gridPrincipalItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="item.valve_opening"
                                    :description="$t('Labels.Opening')"
                                    img="opening"
                                    unit="%"
                                  ></valueItem>
                                  <valueItem
                                    :value="item.tipo_abastecimiento == 'R'? $t('Labels.Residential'):$t('Labels.Commercial')"
                                    :description="$t('Labels.Type')"
                                    :img="item.tipo_abastecimiento == 'R'? 'residencial': 'comercial'"
                                  ></valueItem>
                                  <vs-divider/>
                                  <valueItem
                                    :value="formDate(item.updated_at, 'dayJs')"
                                    :description="$t('Labels.LastUpdated')"
                                    img="fecha"
                                  ></valueItem>
                                  <div class="text-center"><vs-button color="primary"  size="regular" @click="deviceInformation(item.id)">Ver Más</vs-button></div>
                                </div>
                              </l-popup>
                          </l-marker>
                        </div>
                    </l-map>
                    <vs-popup :title="$t('Labels.Alerts')" :active.sync="popupActive">
                      <div class="w-full flex">
                        <div class="lg:w-1/2 sm:w-1/2 ml-10">
                          <statusItem class="mb-5"
                            :status="itemDetail.batterystate === false ?'success-spore':'danger-spore'"
                            :description="$t('Labels.BatteryVoltage')"
                            v-if="itemDetail.meter_type === '0'"
                          />
                          <statusItem class="mb-5"
                            :status="itemDetail.pipeburst === false ?'success-spore':'danger-spore'"
                            :description="$t('Labels.PipeBurst')"
                          />
                          <statusItem class="mb-5"
                            :status="itemDetail.pipeleak === false ?'success-spore':'danger-spore'"
                            :description="$t('Labels.PipeLeak')"
                          />
                          <statusItem class="mb-5"
                            :status="itemDetail.tempsensor === false ?'success-spore':'danger-spore'"
                            :description="itemDetail.tempsensor === false ?$t('Labels.TempSensor'):`${$t('Labels.TempSensor')} ${$t('Labels.OperationRisk')}`"
                          />
                        </div>
                        <div class="lg:w-2/2 sm:w-2/2 ml-5">
                          <statusItem class="mb-5"
                            :status="itemDetail.transducerfault === false ?'success-spore':'danger-spore'"
                            :description="$t('Labels.TransducerFail')"
                            v-if="itemDetail.meter_type === '0'"
                          />
                          <statusItem class="mb-5"
                            :status="itemDetail.intallationdirection === false ?'success-spore':'danger-spore'"
                            :description="$t('Labels.InstallationDirection')"
                          />
                          <statusItem class="mb-8"
                            :status="itemDetail.errorinstallation === false ?'success-spore':'danger-spore'"
                            :description="$t('Labels.ErrorInstallation')"
                          />
                        </div>
                      </div>
                    </vs-popup>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControl,
  LControlLayers,
  LControlAttribution,
  LRectangle
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import { request } from '@/request.js'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import { empty, openingToPercent } from '@/helpers.js'
import SelectArea from 'leaflet-area-select'

import iconBase from '@/components/icons/iconBase'
import iconFilter from '@/components/icons/iconFilter'
import vSelect from 'vue-select'
import LHeatmap from 'tf-vue-leaflet-heatmap'
import statusItem from '@/components/statusItem/statusItem.vue'

/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  name: 'mapa',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControl,
    LControlLayers,
    LControlAttribution,
    LRectangle,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    gridPrincipalItem,
    valueItem,
    alertItem,
    SelectArea,
    iconBase,
    iconFilter,
    vSelect,
    LHeatmap,
    statusItem
  },
  data () {
    return {
      popupActive: false,
      itemDetail: {},
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      markers: [],
      status_mapa: false,
      dashboard: {
        gaugesCount: 0,
        totalMeters: 0,
        totalPerHour: 0,
        alert: 0,
        noAlert: 0
      },
      filters:{
        num_medidor:'',
        num_cta:'',
        type: '',
        minMts3: '',
        maxMts3: '',
        minFlow: '',
        maxFlow: '',
        alerted: '',
        uuids: []
      },
      banderaFullscreen: true,
      rectangle: {
        latlngs: [],
        style: { color: '#140050', weight: 1 },
        visible: false
      },
      arrayUuids: [],
      banderaArea: false,
      banderaFilter: false,
      banderaCluster: true,
      banderaHeatMap: false,
      showFiltrar: false,
      types: [
        {label: this.$t('Labels.All'), value:''},
        {label: 'Ultrasónico', value: '0'},
        {label: 'IM-A', value: '2'},
        {label: 'IM-N', value: '1'}
      ],
      maxFlow: 0,
      latlngs: [],
      jsonResponse: []
    }
  },
  methods: {
    nameAlert (alerts) {
      const arreglo = []
      alerts = this.jsonResponse.filter(e => { return e.watersonic_id === alerts.id }).length > 0 ? this.jsonResponse.filter(e => { return e.watersonic_id === alerts.id })[0] : []
      if (alerts.batterystate === true) { arreglo.push('BatteryState') }
      if (alerts.pipeburst === true) { arreglo.push('PipeBurst') }
      if (alerts.pipeleak === true) { arreglo.push('PipeLeak') }
      if (alerts.tempsensor === true) { arreglo.push('TempSensor') }
      if (alerts.transducerfault === true) { arreglo.push('TransducerFail') }
      if (alerts.intallationdirection === true) { arreglo.push('InstallationDirection') }
      if (alerts.errorinstallation === true) { arreglo.push('ErrorInstallation') }
      return {name: arreglo[0], count:arreglo.length}
    },
    getDetailLog (item) {
      this.itemDetail = this.jsonResponse.filter(e => { return e.watersonic_id === item.id }).length > 0 ? this.jsonResponse.filter(e => { return e.watersonic_id === item.id })[0] : []
      this.popupActive = true
    },
    async filterHeatMap () {
      this.latlngs = []
      const params = {
        url: 'water_devices/heatmap',
        method: 'GET'
      }
      await request(params).then(data => {
        data.data.data.forEach(element => {
          this.latlngs.push([element.lat, element.long, element.n])
        })
        this.banderaHeatMap = !this.banderaHeatMap
      })
    },
    filterCluster () {
      this.banderaCluster = !this.banderaCluster
    },
    seleccionArea () {
      const maps = this.$refs.mymap.mapObject
      this.rectangle.latLng = []
      this.arrayUuids = []
      
      if (maps.selectArea.enabled()) {
        this.banderaArea = false
        maps.selectArea.disable()
        maps.selectArea.setShiftKey(true)
        maps.selectArea.setControlKey(false)
        // this.getMapa()
      } else {
        this.banderaCluster = false
        this.banderaArea = true
        this.banderaFilter = true
        maps.selectArea.enable()
        maps.selectArea.setShiftKey(false)
        maps.selectArea.setControlKey(false)
      }

    },
    filterAdd (val) {
      const maps = this.$refs.mymap.mapObject
      if (val === true || val === false) { 
        this.banderaFilter = true 
      } else {
        this.banderaArea = false
        maps.selectArea.disable()
        this.banderaFilter = false
        maps.selectArea.setShiftKey(true)
        maps.selectArea.setControlKey(false)
        val = ''
      }
      this.banderaHeatMap = false
      this.filters.alerted = val
      this.markers = []
      this.rectangle.latlngs = []
      this.rectangle.visible = false
      this.arrayUuids = []
      this.getMapa()
    },
    openingToPercent (value) {
      return openingToPercent(value)
    },
    async getMapa () {
      this.$vs.loading()
      this.filters.uuids = this.arrayUuids
      this.filters.alerted = this.filters.alerted === null ? '' : this.filters.alerted.toString()
      const params = {
        url: 'water_devices/map/get',
        method: 'POST',
        params: this.filters,
        message: '0'
      }
      await request(params).then(data => {
        const datos = data.data.data
        data = data.data.data.rows
        this.jsonResponse = data
        this.markers = []
        const positions = []
        this.maxFlow = datos.max_flow
        this.dashboard.gaugesCount = datos.count
        this.dashboard.totalMeters = datos.consumptionDevices.toFixed(3)
        this.dashboard.totalPerHour = datos.flow.toFixed(3)
        this.dashboard.alert = datos.alerted
        this.dashboard.noAlert = datos.no_alerted
        for (const value of data) {
          if (!empty(value.latlong)) {
            positions.push([value.latlong.split(',')[0], value.latlong.split(',')[1]])
            if (value.deviceType === 'water') {
              this.markers.push({
                position: { lat: (value.latlong.split(',')[0]).trim(), lng: (value.latlong.split(',')[1]).trim() },
                num_cta: value.num_cta,
                num_alert: value.num_alert,
                ultima_lectura: value.ultima_lectura,
                id: value.watersonic_id,
                num_medidor: value.num_medidor,
                mts3: parseFloat(value.mts3).toFixed(2),
                flow: parseFloat(value.flow).toFixed(2),
                status: value.num_alert === 1 ? 1 : 0,
                draggable: false,
                visible: true,
                meter_type: value.meter_type,
                deviceType: value.deviceType
              })
            } else {
              this.markers.push({
                position: { lat: value.latlong.split(',')[0], lng: value.latlong.split(',')[1] },
                num_valve: value.num_valve,
                updated_at: value.updated_at,
                id: value.uuid,
                valve_opening: openingToPercent(value.valve_opening),
                tipo_abastecimiento: value.tipo_abastecimiento,
                draggable: false,
                visible: true,
                deviceType: value.deviceType
              })
            }
          }
        }

        this.status_mapa = true

        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          maps.fitBounds(positions)
          if (app.banderaFullscreen) {  
            maps.addControl(new L.Control.Fullscreen())
            app.banderaFullscreen = false 
            maps.on({
              'areaselected': (evt) => {
                app.rectangle.visible = false
                app.rectangle.latlngs = [[evt.bounds._northEast.lat, evt.bounds._northEast.lng], [evt.bounds._southWest.lat, evt.bounds._southWest.lng]]
                app.rectangle.visible = true
                app.arrayUuids = []
                L.Util.requestAnimFrame(() => {
                  maps.eachLayer((pointLayer) => {
                    if (pointLayer instanceof L.Marker) {
                      if (evt.bounds.contains(pointLayer.getLatLng())) {
                        app.markers.filter(e => { return parseFloat(e.position.lat) === parseFloat(pointLayer.getLatLng().lat) && parseFloat(e.position.lng) === parseFloat(pointLayer.getLatLng().lng) })[0].status = 11
                        app.arrayUuids.push(app.markers.filter(e => { return parseFloat(e.position.lat) === parseFloat(pointLayer.getLatLng().lat) && parseFloat(e.position.lng) === parseFloat(pointLayer.getLatLng().lng) })[0].id)
                      }
                    }
                  })
                })
                setTimeout(function () {
                  app.getMapa()
                  app.seleccionArea()
                }, 1000)
              }
            })
          }
        }, 1000)
      }).catch(() => {
        this.markers = []
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    deviceInformation (uuid) {
      console.log(uuid)
      window.location.href = `/watermeter/${uuid}`
    }
  },
  sockets: {
    waters (payload) {
      this.markers = this.markers.filter(marker => marker.id !== payload.uuid)
      this.markers.push({
        position: { lat: payload.latlong.split(',')[0], lng: payload.latlong.split(',')[1] },
        num_cta: payload.num_cta,
        num_alert: payload.num_alert,
        ultima_lectura: payload.ultima_lectura,
        id: payload.uuid,
        num_medidor: payload.num_medidor,
        mts3: parseFloat(payload.mts3).toFixed(3),
        flow: parseFloat(payload.flow).toFixed(3),
        status: payload.num_alert === 1 ? 1 : 0,
        draggable: false,
        visible: true
      })
    }
  },
  created () {
    this.getMapa()
  }

}
</script>
